import {sortableHandle} from "react-sortable-hoc";
import React from "react";

const DragHandle = sortableHandle(() => <div className="remove drag-icon"/>);

export default DragHandle